import { useRecoilState, useSetRecoilState } from "recoil";

import { tariffsState } from "@states/tariffs";
import {
    additionalCoverState,
    insuranceChoiceState,
    totalPriceState,
} from "@states/userData";

export function useStateUnsetter() {
    // Recoil setters
    const [chosenInsurance, setChosenInsurance] =
        useRecoilState(insuranceChoiceState);
    const [additionalCover, setAdditionalCover] =
        useRecoilState(additionalCoverState);
    const [tariffData, setTariffData] = useRecoilState(tariffsState);
    const setTotalPrice = useSetRecoilState(totalPriceState);

    // Unset functions to export
    const unsetInsuranceChoiceState = () => {
        if (chosenInsurance !== undefined) {
            setChosenInsurance(undefined);
            setTotalPrice(0);
            unsetAdditionalCoversState();
        }
    };

    const unsetAdditionalCoversState = () => {
        if (additionalCover.length > 0) setAdditionalCover([]);
    };

    const unsetTariffState = () => {
        if (tariffData !== undefined) setTariffData(undefined);
    };

    return {
        unsetInsuranceChoiceState,
        unsetAdditionalCoversState,
        unsetTariffState,
    };
}
